class CreateAccountingEntryReq{

  constructor(id = undefined, title = undefined, amount = undefined,
    description = undefined, category = undefined, entryType = undefined,
    isProfit = undefined, patientId = undefined, accountingSessionId = undefined,
    therapistId = undefined, accountingTherapistHourId = undefined,
    employeeId = undefined, facilityId = undefined, timeStamp = undefined, 
    pageNumber  = undefined, pageSize = undefined) {

    this.id = id;
    this.amount = amount;
    this.title = title;
    this.description = description;
    this.category = category;
    this.entryType = entryType;
    this.employeeId = employeeId;
    this.facilityId = facilityId;
    this.isProfit = isProfit;
    this.patientId = patientId;
    this.accountingSessionId = accountingSessionId;
    this.therapistId = therapistId
    this.accountingTherapistHourId = accountingTherapistHourId;
    this.timeStamp = timeStamp
    this.userId = undefined;
    this.packageId = undefined;
    this.creatorId = undefined;
    this.pagingParams = {
      pageNumber: pageNumber,
      pageSize: pageSize
    }

    
  }
}
export default CreateAccountingEntryReq;